var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarSolid = function SvgCalendarSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71875 9.5H20.2812C20.5391 9.5 20.75 9.71094 20.75 9.96875V20.125C20.75 21.1602 19.9102 22 18.875 22H5.125C4.08984 22 3.25 21.1602 3.25 20.125V9.96875C3.25 9.71094 3.46094 9.5 3.71875 9.5ZM20.75 7.78125V6.375C20.75 5.33984 19.9102 4.5 18.875 4.5H17V2.46875C17 2.21094 16.7891 2 16.5312 2H14.9688C14.7109 2 14.5 2.21094 14.5 2.46875V4.5H9.5V2.46875C9.5 2.21094 9.28906 2 9.03125 2H7.46875C7.21094 2 7 2.21094 7 2.46875V4.5H5.125C4.08984 4.5 3.25 5.33984 3.25 6.375V7.78125C3.25 8.03906 3.46094 8.25 3.71875 8.25H20.2812C20.5391 8.25 20.75 8.03906 20.75 7.78125Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_solid.b287b9ef.svg";
export { ForwardRef as ReactComponent };